import { getCultureFromPage, setCached, getCached } from 'utils';

/** Initialise module.
 * @param (object) $target
 */
function initialise($target) {
  if (!$target || !$target.length) {
    return;
  }

  /** Redirect to suggestion URL when selected.
 * @param (object) event
 * @param (object) suggestion
 * @param (string) name
 */
  const redirect = function redirect(event, suggestion) {
    if (suggestion.url !== undefined) {
      window.location.href = suggestion.url;
    }
  };

  require.ensure(['corejs-typeahead/dist/bloodhound', 'corejs-typeahead/dist/typeahead.jquery', './netc.typeahead.hbs'], () => {
    const Bloodhound = require('corejs-typeahead/dist/bloodhound');
    require('corejs-typeahead/dist/typeahead.jquery');
    const suggestionTemplate = require('./netc.typeahead.hbs');

    const currentCulture = getCultureFromPage();
    const typeaheadCacheKey = `typeahead_search_data_${currentCulture}`;

    const cachedData = getCached(typeaheadCacheKey);
    if (cachedData) {
      initTypeahead(cachedData);
    } else {
      fetch('/api/typeahead/getsearchitems')
      .then(response => response.json())
      .then((jsonData) => {
        setCached(typeaheadCacheKey, jsonData);
        initTypeahead(jsonData);
      });
    }

    function initTypeahead(jsonData) {
      /** The suggestion engine used by Twitter Typeahead. */
      const data = new Bloodhound(
        {
          datumTokenizer(d) { return Bloodhound.tokenizers.whitespace(d.tokens.join(' ')); },
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          limit: 10,
          local: jsonData,
          dupDetector(remoteMatch, localMatch) {
            return (remoteMatch.value === localMatch.value) || (remoteMatch.url === localMatch.url);
          },
        },
      );

      // Start pre-fetch of results.
      data.initialize();

      // Initialise type ahead plugin.
      $target
        .typeahead(null, {
          name: 'ryobi_products',
          displayKey: 'value',
          source: data.ttAdapter(),
          templates: {
            suggestion: suggestionTemplate,
          },
        })
        .on('typeahead:selected', redirect);
    }
  });
}

/**
 * Typeahead module.
 * @exports modules/typeahead
 * @version 0.1.0
 */
export default {
  initialise,
};
